function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5293 5.24025C17.3511 5.24025 19.8127 7.03109 20.9534 9.26964L25.9466 6.77671C24.0254 3.3273 20.5431 0 14.5293 0C6.34405 0 0 5.82024 0 14.3369C0 22.8536 6.34405 28.6738 14.5293 28.6738C20.5431 28.6738 23.9853 25.3058 25.9466 21.8564L20.9534 19.4042C19.8127 21.6936 17.3511 23.4336 14.5293 23.4336C9.57612 23.4336 5.97382 19.567 5.97382 14.3369C5.97382 9.09666 9.57612 5.24025 14.5293 5.24025Z",
  fill: "#9A975A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M74.697 7.60089C71.6651 7.60089 69.0534 9.43243 67.9027 11.2538C67.1622 8.96437 65.321 7.60089 62.4192 7.60089C59.3872 7.60089 56.7656 9.51384 55.955 10.7145V8.09948H50.7617V28.1752H55.955V14.6727C56.7355 13.5534 58.2465 12.3019 60.0477 12.3019C62.179 12.3019 62.9895 13.6348 62.9895 15.4969V28.1752H68.2329V14.632C68.9734 13.5534 70.4843 12.3019 72.3255 12.3019C74.4569 12.3019 75.2774 13.6348 75.2774 15.4969V28.1752H80.5207V13.6755C80.5107 9.55454 78.3393 7.60089 74.697 7.60089Z",
  fill: "#9A975A"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M93.5705 7.60089C87.5567 7.60089 83.334 12.2917 83.334 18.1119C83.334 24.5528 87.8769 28.6636 93.8907 28.6636C96.9627 28.6636 100.075 27.7072 102.036 25.8756L99.7445 22.4669C98.4737 23.7185 96.1422 24.4613 94.4611 24.4613C91.109 24.4613 89.0977 22.3448 88.7675 19.8112H103.457V18.6512C103.477 12.0983 99.4643 7.60089 93.5705 7.60089ZM88.7074 16.2498C88.9476 14.2555 90.3485 11.8033 93.5805 11.8033C97.0227 11.8033 98.3336 14.3369 98.4537 16.2498H88.7074Z",
  fill: "#9A975A"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M123.859 13.8792C126.441 13.3399 128.562 11.0097 128.562 7.51963C128.562 3.82601 125.9 0.458008 120.707 0.458008H106.338V28.1754H121.157C126.351 28.1754 129.092 24.8481 129.092 20.6966C129.102 17.2065 126.771 14.337 123.859 13.8792ZM112.152 5.52528H119.436C121.398 5.52528 122.628 6.81753 122.628 8.5575C122.628 10.2975 121.398 11.549 119.436 11.549H112.152V5.52528ZM119.646 23.0674H112.152V16.6265H119.646C121.938 16.6265 123.169 18.1222 123.169 19.8724C123.169 21.8565 121.858 23.0674 119.646 23.0674Z",
  fill: "#9A975A"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M140.77 7.60089C137.658 7.60089 134.546 8.59806 132.135 10.7552L134.096 14.286C135.777 12.7089 137.738 11.9152 139.87 11.9152C142.492 11.9152 144.213 13.2481 144.213 15.2832V17.9796C142.902 16.4025 140.57 15.5274 137.949 15.5274C134.797 15.5274 131.074 17.3182 131.074 22.009C131.074 26.4963 134.797 28.6535 137.949 28.6535C140.53 28.6535 142.862 27.697 144.213 26.0791V28.1549H149.416V15.212C149.406 9.43243 145.273 7.60089 140.77 7.60089ZM144.203 23.3522C143.342 24.5121 141.711 25.1023 140.03 25.1023C137.989 25.1023 136.308 24.0237 136.308 22.1515C136.308 20.1978 137.989 19.1193 140.03 19.1193C141.711 19.1193 143.342 19.6993 144.203 20.8694V23.3522Z",
  fill: "#9A975A"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M162.994 12.3019C164.795 12.3019 166.226 13.0548 167.167 14.459L170.569 11.2131C169.258 9.38156 166.807 7.60089 162.754 7.60089C156.65 7.60089 152.277 11.9661 152.277 18.1119C152.277 24.2985 156.66 28.6636 162.754 28.6636C166.807 28.6636 169.258 26.8728 170.569 25.0107L167.167 21.8157C166.226 23.1487 164.795 23.9729 162.994 23.9729C159.842 23.9729 157.631 21.602 157.631 18.1119C157.631 14.632 159.842 12.3019 162.994 12.3019Z",
  fill: "#9A975A"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M192.014 8.09961H185.63L178.145 17.0335V0.458008H172.941V28.1754H178.145V23.0267L180.516 20.4422L185.75 28.1754H192.264L184.199 17.2065L192.014 8.09961Z",
  fill: "#9A975A"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M218.17 17.2065L211.536 0.458008H203.4V28.1754H209.204V8.77118L216.899 28.1754H219.441L227.136 8.77118V28.1754H232.989V0.458008H224.804L218.17 17.2065Z",
  fill: "#9A975A"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M271.012 7.60102C268.681 7.60102 266.469 8.6389 264.908 10.6739V0.458008H259.715V28.1754H264.908V25.601C266.469 27.5954 268.631 28.6739 271.012 28.6739C276.005 28.6739 279.768 24.8481 279.768 18.1629C279.768 11.5897 276.045 7.60102 271.012 7.60102ZM269.371 23.973C267.69 23.973 265.769 23.0165 264.908 21.7243V14.6219C265.769 13.289 267.69 12.2918 269.371 12.2918C272.403 12.2918 274.404 14.6626 274.404 18.1527C274.414 21.653 272.403 23.973 269.371 23.973Z",
  fill: "#9A975A"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M287.875 8.09955H282.682V28.1753H287.875V8.09955Z",
  fill: "#9A975A"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M297.209 0.458008H292.016V28.1754H297.209V0.458008Z",
  fill: "#9A975A"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M306.535 8.09955H301.342V28.1753H306.535V8.09955Z",
  fill: "#9A975A"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M303.924 5.43351C305.365 5.43351 306.536 4.25318 306.536 2.78795C306.536 1.32271 305.365 0.172913 303.924 0.172913C302.513 0.172913 301.312 1.32271 301.312 2.78795C301.312 4.25318 302.513 5.43351 303.924 5.43351Z",
  fill: "#9A975A"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M285.422 0.172913C284.011 0.172913 282.811 1.32271 282.811 2.78795C282.811 4.25318 284.011 5.43351 285.422 5.43351C286.863 5.43351 288.034 4.25318 288.034 2.78795C288.034 1.32271 286.863 0.172913 285.422 0.172913Z",
  fill: "#9A975A"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M319.764 23.973C318.623 23.973 317.963 23.0165 317.963 21.7752V12.7192H321.445L319.704 8.1098H317.963V2.61517H312.719V8.09963H309.447V12.709H312.719V23.1793C312.719 26.7508 314.681 28.6638 318.323 28.6638C320.494 28.6638 321.885 28.0838 322.666 27.3715L321.565 23.3828C321.285 23.6881 320.544 23.973 319.764 23.973Z",
  fill: "#9A975A"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M332.392 21.7546L327.238 7.79413H321.955V7.96711L325.978 18.6002L325.938 18.6206L329.7 28.1548L328.96 29.8541C328.469 30.9326 327.569 31.3091 326.218 31.3091C325.728 31.3091 325.027 31.187 324.577 30.9733L323.796 35.715C324.447 35.8778 325.758 36.0101 326.378 36.0101C329.78 35.9287 332.392 34.9315 333.873 31.1463L343.159 7.79413H337.555L332.392 21.7546Z",
  fill: "#9A975A"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M353.776 1.96371L353.756 1.94336L347.562 8.24183L349.174 9.88004L353.776 5.18926L352.195 3.5714L353.776 1.96371Z",
  fill: "#9A975A"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M353.795 1.94336L353.775 1.96371L355.366 3.5714L353.775 5.18926L358.388 9.88004L359.999 8.24183L353.795 1.94336Z",
  fill: "#9A975A"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M353.768 1.96187L352.184 3.57349L353.768 5.18417L355.352 3.57256L353.768 1.96187Z",
  fill: "#9A975A"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M250.611 15.1915C251.071 16.0971 251.311 17.1553 251.311 18.2746C251.311 21.3882 249.5 24.044 246.308 24.044C244.987 24.044 243.906 23.5759 243.096 22.823L239.604 26.3741C241.315 27.7986 243.576 28.6737 246.308 28.6737C252.762 28.6737 256.634 23.9219 256.634 18.2746C256.634 15.6901 255.804 13.2888 254.283 11.4572L250.611 15.1915Z",
  fill: "#9A975A"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M241.355 18.2748C241.355 15.2019 243.126 12.5462 246.318 12.5462C247.529 12.5462 248.549 12.9328 249.34 13.5841L252.832 10.0329C251.151 8.72029 248.95 7.91644 246.318 7.91644C239.904 7.91644 236.031 12.6683 236.031 18.2748C236.031 20.7779 236.792 23.0979 238.193 24.9091L241.925 21.1137C241.555 20.2692 241.355 19.2924 241.355 18.2748Z",
  fill: "#9A975A"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M38.0336 28.8773C44.6178 28.8773 48.5603 24.0339 48.5603 18.2747C48.5603 12.5562 44.6078 7.71283 38.0336 7.71283C31.4994 7.71283 27.5469 12.5562 27.5469 18.2747C27.5469 24.0441 31.4994 28.8773 38.0336 28.8773ZM38.0336 12.4341C41.2857 12.4341 43.1369 15.1509 43.1369 18.2747C43.1369 21.4494 41.2857 24.156 38.0336 24.156C34.7815 24.156 32.9804 21.4392 32.9804 18.2747C32.9703 15.1509 34.7815 12.4341 38.0336 12.4341Z",
  fill: "#9A975A"
});

function SvgLogoMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 36,
    viewBox: "0 0 360 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMedium);
export default __webpack_public_path__ + "static/media/logo-medium.75c9d85c.svg";
export { ForwardRef as ReactComponent };